import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { MapPin, ArrowRight } from "lucide-react";
import useSeo from "@/hooks/useSeo";
import { api } from "@/lib/api";

export default function ServiceAreas() {
  useSeo({
    title: "Service Areas | MD · DC · VA | Full Indoor Air Services",
    description: "Air duct cleaning across Maryland, Washington DC, and Virginia — Bethesda, Rockville, Arlington, Alexandria, Fairfax, and more.",
    canonical: "https://capitalindoorair.com/service-areas",
  });

  const [cities, setCities] = useState([]);
  useEffect(() => {
    api.get("/cities").then((r) => setCities(r.data.cities || [])).catch(() => {});
  }, []);

  const grouped = cities.reduce((acc, c) => {
    acc[c.state] = acc[c.state] || [];
    acc[c.state].push(c);
    return acc;
  }, {});

  return (
    <div className="bg-bone" data-testid="service-areas-page">
      <section className="section-pad">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-3xl">
            <div className="eyebrow mb-3">Service Areas</div>
            <h1 className="font-heading text-5xl md:text-6xl tracking-tighter font-light">
              Serving <span className="text-forest">Maryland, DC,</span> & <span className="text-forest">Virginia.</span>
            </h1>
            <p className="mt-6 text-lg text-muted2 leading-relaxed">
              Same-week appointments available in most of our service cities.
              Don't see your town? Call us — we likely cover it.
            </p>
          </div>

          <div className="mt-16 space-y-12">
            {["MD", "DC", "VA"].map((state) => (
              <div key={state} data-testid={`state-${state}`}>
                <h2 className="font-heading text-3xl tracking-tight mb-6 flex items-center gap-3">
                  <span className="inline-flex px-3 py-1 rounded-full bg-forest/10 text-forest text-xs uppercase tracking-[0.22em]">
                    {state === "MD" ? "Maryland" : state === "DC" ? "Washington DC" : "Virginia"}
                  </span>
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                  {(grouped[state] || []).map((c) => (
                    <Link
                      key={c.slug}
                      to={`/service-areas/${c.slug}`}
                      className="card-surface p-6 hover-lift flex items-center justify-between group"
                      data-testid={`city-card-${c.slug}`}
                    >
                      <div className="flex items-center gap-3">
                        <MapPin size={18} className="text-forest" />
                        <div>
                          <div className="font-heading text-lg">{c.name}</div>
                          <div className="text-xs text-muted2 uppercase tracking-[0.18em]">{state}</div>
                        </div>
                      </div>
                      <ArrowRight size={16} className="text-muted2 group-hover:text-forest transition" />
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
